import Terms from './Terms';

const TermsComponent = () => <Terms />;

export default TermsComponent;
